// ==========================================================================
// tabs.js — DESIGN-SPEC-v2 §5. Vanilla, no libraries.
// Wires every [data-tabs] container: buttons with role=tab inside a
// role=tablist drive sibling role=tabpanel elements (matched via
// aria-controls). Keyboard: ArrowLeft/ArrowRight move + activate
// (roving tabindex), Home/End jump to first/last. aria-selected and the
// panels' hidden attribute are kept in sync. Idempotent per container, so
// re-running init (e.g. after a theme-editor section re-render) is safe.
// No JS: markup pre-hides all but the first panel, whose links still work.
// ==========================================================================
(function () {
  'use strict';

  function initTabs(root) {
    if (root.__elTabsWired) return;
    root.__elTabsWired = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (tabs.length === 0) return;

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
      });
      panels.forEach(function (p) {
        p.hidden = p.id !== tab.getAttribute('aria-controls');
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          select(next, true);
        }
      });
    });

    // Normalise initial state to whatever the markup marked selected.
    var initial = null;
    tabs.forEach(function (t) {
      if (!initial && t.getAttribute('aria-selected') === 'true') initial = t;
    });
    select(initial || tabs[0], false);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-tabs]'), initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor injects/re-renders sections without a page load.
  document.addEventListener('shopify:section:load', initAll);
})();
